<template>
    <div class="page--container" style="--offset-top: 86px;--offset-bottom: 0;">
        <van-nav-bar title="先导应用市场" />
        <van-notice-bar text="原域名app.leadchina.cn已变更为app.leadintelligent.com，请知悉" left-icon="volume-o" />
        <div class="page-content--wrapper scoll-y" style="top: 86px;">
            <div class="app-list-wrapper">
                <app-shortinfo-card style="margin-bottom: 9px" 
                    v-for="(app, index) in apps" 
                    :key="index" 
                    :app="app" 
                    @click.native="showAppDetail(app)" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {}
    },
    computed: {
        apps () {
            return this.$store.state.apps
        }
    },
    methods: {
        showAppDetail: function (app) {
            this.$router.push({ 
                name: 'AppDetailPage', 
                params: { id: app.id },
                query: { from: 'home' }
            })
        }
    }
}
</script>

<style lang="scss" scoped>

.app-list-wrapper {
    margin: 9px 15px;
}

</style>


